import React, { useEffect, useState } from "react";
import Layout from "./../../Component/Layout/Layout";
import { useTheme } from "../../Context/ThemeContext";
import { useAuth } from "../../Context/auth";
import axios from "axios";
import { toast } from "react-toastify";
import {
  FiCopy,
  FiDollarSign,
  FiUsers,
  FiLink,
  FiActivity,
  FiChevronDown,
  FiClock,
  FiCheckCircle,
  FiXCircle,
} from "react-icons/fi";
import Modal from "react-modal";
import { FaSpinner } from "react-icons/fa";
import AnimatedPromoCard from "./AnimatedPromoCard ";

const UserDashboard = () => {
  const { darkMode } = useTheme();
  const [auth] = useAuth();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [recentActivity, setRecentActivity] = useState([]);
  const [deposits, setDeposits] = useState([]);
  const [activePlan, setActivePlan] = useState(null);
  const [isPlanModalOpen, setIsPlanModalOpen] = useState(false);
  const [advances, setAdvances] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [advanceForm, setAdvanceForm] = useState({
    teamCategory: "",
    amountRequested: 0,
    userComment: "",
    remarks: "",
  });

  const [latestCashout, setLatestCashout] = useState(null);
  const [isCashoutModalOpen, setIsCashoutModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("request");
  const [cashouts, setCashouts] = useState([]);
  const [cashoutForm, setCashoutForm] = useState({
    amount: "",
    accountType: "",
    accountNumber: "",
    remarks: "",
  });
  const [defaultNote] = useState();
  const [isAdvanceModalOpen, setIsAdvanceModalOpen] = useState(false);

  // Modal styles
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: darkMode ? "#1e293b" : "#ffffff",
      color: darkMode ? "#f8fafc" : "#1e293b",
      border: "none",
      borderRadius: "12px",
      padding: "24px",
      maxWidth: "500px",
      width: "90%",
    },
    overlay: {
      backgroundColor: darkMode ? "rgba(0, 0, 0, 0.75)" : "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
  };
  const calculateAdvanceAmount = (teamCategory) => {
    switch (teamCategory) {
      case "1-20":
        return 4;
      case "21-50":
        return 10;
      case "51-100":
        return 30;
      case "100+":
        return 50;
      default:
        return 0;
    }
  };
  // Fetch user's advance requests
  const [advancesLoading, setAdvancesLoading] = useState(false);

  const fetchUserAdvances = async () => {
    try {
      setAdvancesLoading(true);
      const { data } = await axios.get(
        "https://bioopay-full-backend.onrender.com/api/v1/advance/my-advance",
        {
          headers: {
            "Cache-Control": "no-cache",
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      setAdvances(data.data || []);
    } catch (error) {
    } finally {
      setAdvancesLoading(false);
    }
  };

  useEffect(() => {
    if (auth.token) {
      fetchUserAdvances();
    }
  }, [auth.token]);
  // Submit new advance request
  const submitAdvanceRequest = async () => {
    try {
      if (!advanceForm.teamCategory) {
        toast.error("Please select team size category");
        return;
      }

      // Calculate team size at application from category
      const teamSizeAtApplication = parseInt(
        advanceForm.teamCategory.split("-")[1] || "0"
      );

      const response = await axios.post(
        "https://bioopay-full-backend.onrender.com/api/v1/advance/apply",
        {
          teamSizeAtApplication,
          teamCategory: advanceForm.teamCategory,
          amountRequested: advanceForm.amountRequested,
          userComment: advanceForm.userComment,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      toast.success("Advance request submitted successfully!");
      setIsAdvanceModalOpen(false);
      setAdvanceForm({
        teamCategory: "",
        amountRequested: 0,
        userComment: "",
      });
      fetchUserAdvances();
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Failed to submit advance request"
      );
    }
  };
  // Styles object
  const styles = {
    container: {
      minHeight: "100vh",
      backgroundColor: darkMode ? "#0f172a" : "#f8fafc",
      color: darkMode ? "#f8fafc" : "#1e293b",
      transition: "all 0.3s ease",
      padding: "32px 16px",
    },
    content: {
      maxWidth: "1200px",
      margin: "0 auto",
    },
    header: {
      marginBottom: "32px",
    },
    title: {
      fontSize: "32px",
      fontWeight: "700",
      margin: "0 0 8px 0",
      color: darkMode ? "#ffffff" : "#1e293b",
    },
    subtitle: {
      fontSize: "14px",
      color: darkMode ? "#94a3b8" : "#64748b",
      margin: 0,
    },
    statsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
      gap: "24px",
      marginBottom: "32px",
    },
    card: {
      backgroundColor: darkMode ? "#1e293b" : "#ffffff",
      borderRadius: "12px",
      padding: "24px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
      transition: "all 0.3s ease",
      ":hover": {
        transform: "translateY(-4px)",
        boxShadow: "0 10px 15px rgba(0, 0, 0, 0.1)",
      },
    },
    cardHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "16px",
    },
    cardTitle: {
      fontSize: "14px",
      fontWeight: "600",
      color: darkMode ? "#94a3b8" : "#64748b",
      margin: 0,
    },
    cardIcon: {
      width: "40px",
      height: "40px",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: darkMode ? "#334155" : "#f1f5f9",
    },
    cardValue: {
      fontSize: "28px",
      fontWeight: "700",
      margin: "8px 0",
    },
    cardDescription: {
      fontSize: "12px",
      color: darkMode ? "#94a3b8" : "#64748b",
      margin: 0,
    },
    referralLinkContainer: {
      display: "flex",
      alignItems: "center",
      margin: "16px 0",
    },
    referralLink: {
      flex: 1,
      padding: "12px 16px",
      borderRadius: "8px",
      backgroundColor: darkMode ? "#334155" : "#f1f5f9",
      color: darkMode ? "#e2e8f0" : "#1e293b",
      fontSize: "14px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    copyButton: {
      width: "40px",
      height: "40px",
      marginLeft: "8px",
      borderRadius: "8px",
      backgroundColor: darkMode ? "#3b82f6" : "#2563eb",
      color: "#ffffff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "none",
      cursor: "pointer",
      transition: "all 0.2s ease",
      ":hover": {
        backgroundColor: darkMode ? "#2563eb" : "#1d4ed8",
      },
    },
    section: {
      backgroundColor: darkMode ? "#1e293b" : "#ffffff",
      borderRadius: "12px",
      padding: "24px",
      marginBottom: "32px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
    },
    sectionHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "24px",
    },
    sectionTitle: {
      fontSize: "20px",
      fontWeight: "700",
      margin: 0,
      color: darkMode ? "#ffffff" : "#1e293b",
    },
    teamStats: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
      gap: "16px",
    },
    teamCard: {
      backgroundColor: darkMode ? "#334155" : "#f1f5f9",
      borderRadius: "8px",
      padding: "20px",
    },
    teamCardTitle: {
      fontSize: "14px",
      fontWeight: "600",
      color: darkMode ? "#94a3b8" : "#64748b",
      margin: "0 0 16px 0",
    },
    teamCardContent: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "12px",
    },
    teamValue: {
      fontSize: "24px",
      fontWeight: "700",
      margin: "0 0 4px 0",
    },
    teamLabel: {
      fontSize: "12px",
      color: darkMode ? "#94a3b8" : "#64748b",
      margin: 0,
    },
    progressBar: {
      height: "6px",
      width: "100%",
      backgroundColor: darkMode ? "#475569" : "#e2e8f0",
      borderRadius: "3px",
      overflow: "hidden",
    },
    progressFill: {
      height: "100%",
      backgroundColor: "#3b82f6",
      borderRadius: "3px",
    },
    activityItem: {
      display: "flex",
      alignItems: "center",
      padding: "16px 0",
      borderBottom: `1px solid ${darkMode ? "#334155" : "#e2e8f0"}`,
      ":last-child": {
        borderBottom: "none",
      },
    },
    activityIcon: {
      width: "40px",
      height: "40px",
      borderRadius: "8px",
      backgroundColor: darkMode ? "#334155" : "#f1f5f9",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: "16px",
    },
    activityDetails: {
      flex: 1,
    },
    activityAction: {
      fontSize: "14px",
      fontWeight: "600",
      margin: "0 0 4px 0",
      color: darkMode ? "#ffffff" : "#1e293b",
    },
    activityDate: {
      fontSize: "12px",
      color: darkMode ? "#94a3b8" : "#64748b",
      margin: 0,
    },
    activityAmount: {
      fontSize: "14px",
      fontWeight: "700",
    },
    loadingContainer: {
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: darkMode ? "#0f172a" : "#f8fafc",
    },
    loadingContent: {
      textAlign: "center",
    },
    loadingSpinner: {
      width: "48px",
      height: "48px",
      border: `4px solid ${darkMode ? "#334155" : "#e2e8f0"}`,
      borderTopColor: "#3b82f6",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
      margin: "0 auto 16px auto",
    },
    errorContainer: {
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: darkMode ? "#0f172a" : "#f8fafc",
    },
    planCard: {
      backgroundColor: darkMode ? "#334155" : "#f1f5f9",
      borderRadius: "8px",
      padding: "16px",
      marginBottom: "16px",
      cursor: "pointer",
      transition: "all 0.2s ease",
      ":hover": {
        transform: "translateY(-2px)",
      },
    },
    activePlanCard: {
      backgroundColor: darkMode ? "#1e3a8a" : "#3b82f6",
      color: "#ffffff",
      borderRadius: "8px",
      padding: "16px",
      marginBottom: "16px",
      cursor: "pointer",
      transition: "all 0.2s ease",
      ":hover": {
        transform: "translateY(-2px)",
      },
    },
    planHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "8px",
    },
    planName: {
      fontSize: "18px",
      fontWeight: "700",
      margin: 0,
    },
    planStatus: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 8px",
      borderRadius: "4px",
      backgroundColor: darkMode ? "#10b981" : "#10b981",
      color: "#ffffff",
    },
    planDetails: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "8px",
    },
    planDetailLabel: {
      fontSize: "12px",
      color: darkMode ? "#94a3b8" : "#64748b",
      margin: 0,
    },
    planDetailValue: {
      fontSize: "14px",
      fontWeight: "600",
      margin: 0,
    },
    activePlanDetailLabel: {
      fontSize: "12px",
      color: "rgba(255, 255, 255, 0.8)",
      margin: 0,
    },
    activePlanDetailValue: {
      fontSize: "14px",
      fontWeight: "600",
      margin: 0,
      color: "#ffffff",
    },
    noPlanCard: {
      backgroundColor: darkMode ? "#334155" : "#f1f5f9",
      borderRadius: "8px",
      padding: "16px",
      textAlign: "center",
      cursor: "pointer",
      transition: "all 0.2s ease",
      ":hover": {
        transform: "translateY(-2px)",
      },
    },
    noPlanText: {
      fontSize: "14px",
      color: darkMode ? "#94a3b8" : "#64748b",
      margin: 0,
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "16px",
    },
    tableHeader: {
      backgroundColor: darkMode ? "#334155" : "#e2e8f0",
      color: darkMode ? "#f8fafc" : "#1e293b",
      textAlign: "left",
      padding: "12px",
      fontSize: "14px",
      fontWeight: "600",
    },
    tableRow: {
      borderBottom: `1px solid ${darkMode ? "#334155" : "#e2e8f0"}`,
    },
    tableCell: {
      padding: "12px",
      fontSize: "14px",
    },
    statusPending: {
      color: "#f59e0b",
      fontWeight: "600",
    },
    statusActive: {
      color: "#10b981",
      fontWeight: "600",
    },
    statusCompleted: {
      color: "#3b82f6",
      fontWeight: "600",
    },
    statusCancelled: {
      color: "#ef4444",
      fontWeight: "600",
    },
  };

  // Keyframes for loading spinner
  const spinKeyframes = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });
  // };

  // Fetch user data and deposits
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // Fetch user profile
        const { data: userData } = await axios.get(
          "https://bioopay-full-backend.onrender.com/api/v1/users/user/profile"
        );
        setUserData(userData.user);

        // Fetch user deposits
        const { data: depositsData } = await axios.get(
          "https://bioopay-full-backend.onrender.com/api/v1/deposite/my-deposite"
        );
        setDeposits(depositsData.deposits || []);

        // Find active plan
        const active = depositsData.deposits.find(
          (deposit) => deposit.status === "active"
        );
        setActivePlan(active || null);

        // In your useEffect where you fetch cashouts
        // In your useEffect, change the cashout fetch to:
        try {
          const { data: cashoutsData } = await axios.get(
            `https://bioopay-full-backend.onrender.com/api/v1/cashout/my?t=${Date.now()}`,
            {
              headers: {
                "Cache-Control": "no-cache",
              },
            }
          );

          const cashoutsArray = cashoutsData.cashouts || cashoutsData || [];
          setCashouts(cashoutsArray);

          if (cashoutsArray.length > 0) {
            setLatestCashout(cashoutsArray[0]);
          }
        } catch (error) {}

        setRecentActivity([
          {
            id: 1,
            action: "Royalty Earnings",
            amount: `$${userData.user.totalEarnings}`,
            date: new Date().toISOString().split("T")[0],
            type: "credit",
            icon: <FiDollarSign style={{ color: "#10b981" }} />,
            status: "confirmed",
            statusBadge: (
              <span
                style={{
                  padding: "4px 8px",
                  borderRadius: "12px",
                  fontSize: "12px",
                  fontWeight: "600",
                  backgroundColor: "#dcfce7",
                  color: "#166534",
                }}
              >
                Confirmed
              </span>
            ),
          },
          {
            id: 2,
            action: "Advance Bonus",
            amount: `${advances.length}`,
            date: (() => {
              const pendingCount = advances.filter(
                (a) => a.status === "pending"
              ).length;
              const approvedCount = advances.filter(
                (a) => a.status === "approved"
              ).length;
              return pendingCount > 0
                ? `${pendingCount} pending`
                : approvedCount > 0
                ? `${approvedCount} approved`
                : "No requests";
            })(),
            type: "credit",
            icon: <FiUsers style={{ color: "#3b82f6" }} />,
            status: (() => {
              const pending = advances.some((a) => a.status === "pending");
              const approved = advances.some((a) => a.status === "approved");
              return pending ? "pending" : approved ? "approved" : "none";
            })(),
            statusBadge: (() => {
              const pending = advances.some((a) => a.status === "pending");
              const approved = advances.some((a) => a.status === "approved");
              if (pending) {
                return (
                  <span
                    style={{
                      padding: "4px 8px",
                      borderRadius: "12px",
                      fontSize: "12px",
                      fontWeight: "600",
                      backgroundColor: "#fef9c3",
                      color: "#854d0e",
                    }}
                  >
                    Pending
                  </span>
                );
              } else if (approved) {
                return (
                  <span
                    style={{
                      padding: "4px 8px",
                      borderRadius: "12px",
                      fontSize: "12px",
                      fontWeight: "600",
                      backgroundColor: "#dcfce7",
                      color: "#166534",
                    }}
                  >
                    Approved
                  </span>
                );
              } else {
                return null;
              }
            })(),
          },
          {
            id: 3,
            action: "Withdrawal Processed",
            amount: cashouts.length > 0 ? `$${cashouts[0].amount}` : "$0.00",
            date:
              cashouts.length > 0
                ? new Date(cashouts[0].createdAt).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })
                : new Date().toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  }),
            type: "debit",
            icon: (
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: darkMode ? "#334155" : "#f1f5f9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FiDollarSign
                  style={{
                    color: "#ef4444",
                    fontSize: "18px",
                  }}
                />
              </div>
            ),
            status: cashouts.length > 0 ? cashouts[0].status : "pending",
            accountType: cashouts.length > 0 ? cashouts[0].accountType : "N/A",
            statusBadge: (() => {
              const status =
                cashouts.length > 0 ? cashouts[0].status : "pending";
              const colors = {
                completed: { bg: "#dcfce7", text: "#166534" },
                pending: { bg: "#fef9c3", text: "#854d0e" },
                rejected: { bg: "#fee2e2", text: "#991b1b" },
              };
              return (
                <span
                  style={{
                    padding: "4px 8px",
                    borderRadius: "12px",
                    fontSize: "12px",
                    fontWeight: "600",
                    backgroundColor: colors[status]?.bg || "#fef9c3",
                    color: colors[status]?.text || "#854d0e",
                  }}
                >
                  {status.charAt(0).toUpperCase() + status.slice(1)}
                </span>
              );
            })(),
          },
        ]);

        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch data:", error);
        toast.error("Failed to load dashboard data");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Team performance data
  const teamPerformance = [
    {
      level: 1,
      members: userData?.totalReferred || 0,
      earnings: `$${(userData?.totalReferred || 0) * 10}`,
      progress: Math.min(100, ((userData?.totalReferred || 0) / 10) * 100),
    },
    {
      level: 2,
      members: Math.floor((userData?.totalReferred || 0) * 0.6),
      earnings: `$${Math.floor((userData?.totalReferred || 0) * 0.6) * 20}`,
      progress: Math.min(100, ((userData?.totalReferred || 0) / 20) * 100),
    },
    {
      level: 3,
      members: Math.floor((userData?.totalReferred || 0) * 0.3),
      earnings: `$${Math.floor((userData?.totalReferred || 0) * 0.3) * 30}`,
      progress: Math.min(100, ((userData?.totalReferred || 0) / 30) * 100),
    },
  ];

  const copyToClipboard = () => {
    if (!userData) return;
    navigator.clipboard.writeText(userData.referralLink);
    toast.success("Referral link copied!");
  };

  const openPlanModal = () => {
    setIsPlanModalOpen(true);
  };

  const closePlanModal = () => {
    setIsPlanModalOpen(false);
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "active":
        return <FiCheckCircle style={{ color: "#10b981" }} />;
      case "pending":
        return <FiClock style={{ color: "#f59e0b" }} />;
      case "completed":
        return <FiCheckCircle style={{ color: "#3b82f6" }} />;
      case "cancelled":
        return <FiXCircle style={{ color: "#ef4444" }} />;
      default:
        return <FiClock style={{ color: "#64748b" }} />;
    }
  };
  const getStatusBadge = (status) => {
    switch (status) {
      case "approved":
        return <span style={styles.statusActive}>Approved</span>;
      case "rejected":
        return <span style={styles.statusCancelled}>Rejected</span>;
      default:
        return <span style={styles.statusPending}>Pending</span>;
    }
  };
  if (loading) {
    return (
      <Layout>
        <div style={styles.loadingContainer}>
          <div style={styles.loadingContent}>
            <style>{spinKeyframes}</style>
            <div style={styles.loadingSpinner}></div>
            <p style={{ color: darkMode ? "#94a3b8" : "#64748b" }}>
              Loading dashboard...
            </p>
          </div>
        </div>
      </Layout>
    );
  }

  if (!userData) {
    return (
      <Layout>
        <div style={styles.errorContainer}>
          <p style={{ color: darkMode ? "#94a3b8" : "#64748b" }}>
            Failed to load user data check your internet and try again
          </p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout title={"BIooPay-UserDashBoard"}>
      <div style={styles.container}>
        <style>{spinKeyframes}</style>
        <div style={styles.content}>
          {/* Header */}
          <div style={styles.header}>
            <h1 style={styles.title}>Welcome back, {userData.userName}</h1>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {userData.accountStatus === "active" ? (
                <>
                  <div
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      backgroundColor: "#10B981",
                      boxShadow: "0 0 8px rgba(16, 185, 129, 0.5)",
                    }}
                  ></div>
                  <p
                    style={{
                      ...styles.subtitle,
                      color: "#10B981",
                      fontWeight: "600",
                    }}
                  >
                    Active and earning
                  </p>
                </>
              ) : (
                <p style={styles.subtitle}>
                  Account status: {userData.accountStatus}
                </p>
              )}
            </div>
          </div>
          <AnimatedPromoCard />
          {/* Active Plan Section */}
          <div
            style={{
              position: "fixed",
              top: "90px",
              right: "20px",
              zIndex: 1000,
              fontFamily: "'Inter', sans-serif",
            }}
          >
            {/* Active Plan Indicator */}
            {activePlan ? (
              <div
                style={{
                  position: "relative",
                  backgroundColor: darkMode
                    ? "rgba(16, 185, 129, 0.1)"
                    : "rgba(16, 185, 129, 0.15)",
                  border: `1px solid ${
                    darkMode
                      ? "rgba(16, 185, 129, 0.3)"
                      : "rgba(16, 185, 129, 0.4)"
                  }`,
                  borderRadius: "12px",
                  padding: "12px 16px 12px 40px",
                  cursor: "pointer",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  maxWidth: "220px",
                  ":hover": {
                    transform: "translateY(-2px)",
                    boxShadow: darkMode
                      ? "0 4px 6px rgba(0, 0, 0, 0.3)"
                      : "0 4px 6px rgba(0, 0, 0, 0.1)",
                  },
                }}
                onClick={openPlanModal}
              >
                {/* Status indicator line */}
                <div
                  style={{
                    position: "absolute",
                    left: "12px",
                    top: "12px",
                    bottom: "12px",
                    width: "3px",
                    backgroundColor: "#10B981",
                    borderRadius: "3px",
                  }}
                ></div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#10B981",
                      }}
                    >
                      ACTIVE
                    </span>

                    <div
                      style={{
                        width: "4px",
                        height: "4px",
                        borderRadius: "50%",
                        backgroundColor: darkMode ? "#94a3b8" : "#64748b",
                      }}
                    ></div>

                    <span
                      style={{
                        fontSize: "12px",
                        color: darkMode ? "#94a3b8" : "#64748b",
                      }}
                    >
                      {new Date(activePlan.createdAt).toLocaleDateString()}
                    </span>
                  </div>

                  <span
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      color: darkMode ? "#f8fafc" : "#1e293b",
                      lineHeight: "1.3",
                    }}
                  >
                    {activePlan.plan?.Planename || "Active Plan"}
                  </span>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginTop: "4px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "13px",
                        color: darkMode ? "#94a3b8" : "#64748b",
                      }}
                    >
                      ${activePlan.amount}
                    </span>

                    <div
                      style={{
                        width: "4px",
                        height: "4px",
                        borderRadius: "50%",
                        backgroundColor: darkMode ? "#94a3b8" : "#64748b",
                      }}
                    ></div>

                    <span
                      style={{
                        fontSize: "13px",
                        color: darkMode ? "#94a3b8" : "#64748b",
                      }}
                    >
                      Lifetime
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div
                style={{
                  position: "relative",
                  backgroundColor: darkMode
                    ? "rgba(239, 68, 68, 0.1)"
                    : "rgba(239, 68, 68, 0.1)",
                  border: `1px solid ${
                    darkMode
                      ? "rgba(239, 68, 68, 0.3)"
                      : "rgba(239, 68, 68, 0.3)"
                  }`,
                  borderRadius: "12px",
                  padding: "12px 16px",
                  cursor: "pointer",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  maxWidth: "180px",
                  ":hover": {
                    transform: "translateY(-2px)",
                    boxShadow: darkMode
                      ? "0 4px 6px rgba(0, 0, 0, 0.3)"
                      : "0 4px 6px rgba(0, 0, 0, 0.1)",
                  },
                }}
                onClick={openPlanModal}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <div
                    style={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      backgroundColor: "#EF4444",
                      flexShrink: 0,
                    }}
                  ></div>

                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: darkMode ? "#f8fafc" : "#1e293b",
                    }}
                  >
                    No Active Plan
                  </span>
                </div>

                <span
                  style={{
                    display: "block",
                    fontSize: "12px",
                    color: darkMode ? "#94a3b8" : "#64748b",
                    marginTop: "4px",
                  }}
                >
                  Click to view deposits
                </span>
              </div>
            )}
          </div>
          {/* Stats Grid */}
          <div style={styles.statsGrid}>
            {/* Total Earnings Card */}
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <h3 style={styles.cardTitle}>Royalty Earnings</h3>
                <div style={styles.cardIcon}>
                  <FiDollarSign
                    style={{ color: darkMode ? "#3b82f6" : "#2563eb" }}
                  />
                </div>
              </div>
              <p style={{ ...styles.cardValue, color: "#10b981" }}>
                $
                {userData.earnings
                  ? parseFloat(userData.totalEarnings)
                      .toFixed(1)
                      .replace(/\.0$/, "")
                  : "0"}
              </p>
              <p style={styles.cardDescription}>Lifetime royalty earnings</p>
            </div>

            {/* Available Earnings Card */}
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <h3 style={styles.cardTitle}>Available Balance</h3>
                <div style={styles.cardIcon}>
                  <FiDollarSign
                    style={{ color: darkMode ? "#3b82f6" : "#2563eb" }}
                  />
                </div>
              </div>
              <p style={{ ...styles.cardValue, color: "#10b981" }}>
                $
                {userData.earnings
                  ? parseFloat(userData.earnings).toFixed(1).replace(/\.0$/, "")
                  : "0"}
              </p>

              <p style={styles.cardDescription}>Ready for withdrawal</p>
            </div>

            {/* Referrals Card */}
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <h3 style={styles.cardTitle}>Total Referrals</h3>
                <div style={styles.cardIcon}>
                  <FiUsers
                    style={{ color: darkMode ? "#3b82f6" : "#2563eb" }}
                  />
                </div>
              </div>
              <p style={{ ...styles.cardValue, color: "#3b82f6" }}>
                {userData.totalReferred || 0}
              </p>
              <p style={styles.cardDescription}>Active in your network</p>
            </div>
            {/* Latest Cashout Card */}
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <h3 style={styles.cardTitle}>Latest Withdrawal</h3>
                <div style={styles.cardIcon}>
                  <FiDollarSign
                    style={{ color: darkMode ? "#3b82f6" : "#2563eb" }}
                  />
                </div>
              </div>

              {latestCashout ? (
                <>
                  <p style={{ ...styles.cardValue, color: "#3b82f6" }}>
                    ${latestCashout.amount}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "8px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "12px",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        backgroundColor:
                          latestCashout.status === "pending"
                            ? darkMode
                              ? "rgba(245, 158, 11, 0.1)"
                              : "rgba(245, 158, 11, 0.15)"
                            : latestCashout.status === "approved"
                            ? darkMode
                              ? "rgba(16, 185, 129, 0.1)"
                              : "rgba(16, 185, 129, 0.15)"
                            : darkMode
                            ? "rgba(239, 68, 68, 0.1)"
                            : "rgba(239, 68, 68, 0.15)",
                        color:
                          latestCashout.status === "pending"
                            ? "#f59e0b"
                            : latestCashout.status === "approved"
                            ? "#10b981"
                            : "#ef4444",
                        fontWeight: "600",
                      }}
                    >
                      {latestCashout.status.charAt(0).toUpperCase() +
                        latestCashout.status.slice(1)}
                    </span>
                  </div>
                </>
              ) : (
                <p
                  style={{
                    ...styles.cardValue,
                    color: darkMode ? "#94a3b8" : "#64748b",
                  }}
                >
                  No withdrawals yet
                </p>
              )}

              <button
                onClick={() => setIsCashoutModalOpen(true)}
                style={{
                  width: "100%",
                  padding: "10px",
                  backgroundColor: darkMode ? "#3b82f6" : "#2563eb",
                  color: "#ffffff",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "600",
                  marginTop: "12px",
                  transition: "all 0.2s ease",
                  ":hover": {
                    backgroundColor: darkMode ? "#2563eb" : "#1d4ed8",
                  },
                }}
              >
                Request Withdrawal
              </button>
            </div>
            <div
              style={{
                ...styles.card,
                position: "relative",
              }}
            >
              <div style={styles.cardHeader}>
                <h3 style={styles.cardTitle}>Advance Requests</h3>
                <div style={styles.cardIcon}>
                  <FiDollarSign
                    style={{ color: darkMode ? "#3b82f6" : "#2563eb" }}
                  />
                </div>
              </div>
              <p style={styles.cardValue}>{advances.length}</p>
              <p style={styles.cardDescription}>
                {advances.some((a) => a.status === "pending")
                  ? `${
                      advances.filter((a) => a.status === "pending").length
                    } pending`
                  : "No pending requests"}
              </p>
              <button
                onClick={() => setIsAdvanceModalOpen(true)}
                style={{
                  width: "100%",
                  padding: "10px",
                  backgroundColor: darkMode ? "#3b82f6" : "#2563eb",
                  color: "#ffffff",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "600",
                  marginTop: "12px",
                  transition: "all 0.2s ease",
                  ":hover": {
                    backgroundColor: darkMode ? "#2563eb" : "#1d4ed8",
                  },
                }}
              >
                Request Advance
              </button>
            </div>
            {/* Referral Link Card */}
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <h3 style={styles.cardTitle}>Your Referral Link</h3>
                <div style={styles.cardIcon}>
                  <FiLink style={{ color: darkMode ? "#3b82f6" : "#2563eb" }} />
                </div>
              </div>
              <div style={styles.referralLinkContainer}>
                <div style={styles.referralLink}>{userData.referralLink}</div>
                <button style={styles.copyButton} onClick={copyToClipboard}>
                  <FiCopy />
                </button>
              </div>
              <p style={styles.cardDescription}>Share to earn more rewards</p>
            </div>
          </div>

          {/* Team Performance */}
          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>Team Performance</h2>
              <FiActivity style={{ color: darkMode ? "#3b82f6" : "#2563eb" }} />
            </div>

            <div style={styles.teamStats}>
              {teamPerformance.map((stat, index) => (
                <div key={index} style={styles.teamCard}>
                  <h3 style={styles.teamCardTitle}>Level {stat.level} Team</h3>
                  <div style={styles.teamCardContent}>
                    <div>
                      <p style={styles.teamValue}>{stat.members}</p>
                      <p style={styles.teamLabel}>Members</p>
                    </div>
                    <div>
                      <p style={{ ...styles.teamValue, color: "#10b981" }}>
                        {stat.earnings}
                      </p>
                      <p style={styles.teamLabel}>Earnings</p>
                    </div>
                  </div>
                  <div style={styles.progressBar}>
                    <div
                      style={{
                        ...styles.progressFill,
                        width: `${stat.progress}%`,
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Recent Activity */}
          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>Recent Activity</h2>
            </div>
            <div>
              {recentActivity.map((activity) => (
                <div key={activity.id} style={styles.activityItem}>
                  <div style={styles.activityIcon}>{activity.icon}</div>
                  <div style={styles.activityDetails}>
                    <p style={styles.activityAction}>{activity.action}</p>
                    <p style={styles.activityDate}>{activity.date}</p>
                  </div>
                  <div
                    style={{
                      ...styles.activityAmount,
                      color: activity.type === "credit" ? "#10b981" : "#ef4444",
                    }}
                  >
                    {activity.type === "credit" ? "+" : "-"}
                    {activity.amount}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Plan Details Modal */}
      <Modal
        isOpen={isPlanModalOpen}
        onRequestClose={closePlanModal}
        style={customStyles}
        contentLabel="Plan Details"
      >
        <h2 style={{ ...styles.sectionTitle, marginBottom: "24px" }}>
          {activePlan ? "Active Plan Details" : "Your Deposits"}
        </h2>

        {activePlan && (
          <div style={{ marginBottom: "24px" }}>
            <div style={styles.activePlanCard}>
              <div style={styles.planHeader}>
                <h3 style={{ ...styles.planName, color: "#ffffff" }}>
                  {activePlan.plan?.Planename || "Active Plan"}
                </h3>
                <span style={styles.planStatus}>ACTIVE</span>
              </div>
              <div style={styles.planDetails}>
                <div>
                  <p style={styles.activePlanDetailLabel}>Amount</p>
                  <p style={styles.activePlanDetailValue}>
                    ${activePlan.amount}
                  </p>
                </div>

                <div>
                  <p style={styles.activePlanDetailLabel}>Duration</p>
                  <p style={styles.activePlanDetailValue}>Lifetime</p>
                </div>
              </div>
            </div>
          </div>
        )}

        <h3
          style={{
            ...styles.sectionTitle,
            fontSize: "18px",
            marginBottom: "16px",
          }}
        >
          All Deposits
        </h3>

        {deposits.length > 0 ? (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.tableHeader}>Plan</th>
                <th style={styles.tableHeader}>Amount</th>
                <th style={styles.tableHeader}>Date</th>
                <th style={styles.tableHeader}>Status</th>
              </tr>
            </thead>
            <tbody>
              {deposits.map((deposit) => (
                <tr key={deposit._id} style={styles.tableRow}>
                  <td style={styles.tableCell}>
                    {deposit.plan?.Planename || "N/A"}
                  </td>
                  <td style={styles.tableCell}>${deposit.amount}</td>
                  <td style={styles.tableCell}>
                    {new Date(deposit.createdAt).toLocaleDateString()}
                  </td>
                  <td style={styles.tableCell}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {getStatusIcon(deposit.status)}
                      <span
                        style={{
                          marginLeft: "8px",
                          ...(deposit.status === "pending"
                            ? styles.statusPending
                            : deposit.status === "active"
                            ? styles.statusActive
                            : deposit.status === "completed"
                            ? styles.statusCompleted
                            : styles.statusCancelled),
                        }}
                      >
                        {deposit.status.charAt(0).toUpperCase() +
                          deposit.status.slice(1)}
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p
            style={{
              textAlign: "center",
              color: darkMode ? "#94a3b8" : "#64748b",
            }}
          >
            No deposits found
          </p>
        )}

        <button
          onClick={closePlanModal}
          style={{
            marginTop: "24px",
            padding: "12px 24px",
            backgroundColor: darkMode ? "#3b82f6" : "#2563eb",
            color: "#ffffff",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "600",
            width: "100%",
          }}
        >
          Close
        </button>
      </Modal>
      {/* Cashout Request Modal */}
      <Modal
        isOpen={isCashoutModalOpen}
        onRequestClose={() => setIsCashoutModalOpen(false)}
        style={{
          overlay: {
            backgroundColor: darkMode
              ? "rgba(0, 0, 0, 0.75)"
              : "rgba(0, 0, 0, 0.5)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
          content: {
            position: "relative",
            top: "auto",
            left: "auto",
            right: "auto",
            bottom: "auto",
            width: "100%",
            maxWidth: "500px",
            border: "none",
            borderRadius: "12px",
            padding: "0",
            background: darkMode ? "#1e293b" : "#ffffff",
            boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
            overflow: "hidden",
          },
        }}
        contentLabel="Withdrawal"
      >
        {/* Tabs */}
        <div
          style={{
            display: "flex",
            borderBottom: `1px solid ${darkMode ? "#334155" : "#e2e8f0"}`,
          }}
        >
          <button
            onClick={() => setActiveTab("request")}
            style={{
              flex: 1,
              padding: "16px",
              border: "none",
              background:
                activeTab === "request"
                  ? darkMode
                    ? "#334155"
                    : "#f1f5f9"
                  : "transparent",
              color: darkMode ? "#f8fafc" : "#1e293b",
              fontWeight: "600",
              cursor: "pointer",
              borderBottom:
                activeTab === "request"
                  ? `2px solid ${darkMode ? "#6366f1" : "#4f46e5"}`
                  : "none",
            }}
          >
            Request Withdrawal
          </button>
          <button
            onClick={() => setActiveTab("history")}
            style={{
              flex: 1,
              padding: "16px",
              border: "none",
              background:
                activeTab === "history"
                  ? darkMode
                    ? "#334155"
                    : "#f1f5f9"
                  : "transparent",
              color: darkMode ? "#f8fafc" : "#1e293b",
              fontWeight: "600",
              cursor: "pointer",
              borderBottom:
                activeTab === "history"
                  ? `2px solid ${darkMode ? "#6366f1" : "#4f46e5"}`
                  : "none",
            }}
          >
            Withdrawal History
          </button>
        </div>

        {/* Close Button */}
        <button
          onClick={() => setIsCashoutModalOpen(false)}
          style={{
            position: "absolute",
            top: "16px",
            right: "16px",
            background: "none",
            border: "none",
            color: darkMode ? "#94a3b8" : "#64748b",
            fontSize: "20px",
            cursor: "pointer",
            padding: "4px",
          }}
        >
          ×
        </button>

        {/* Tab Content */}
        <div style={{ padding: "24px" }}>
          {activeTab === "request" ? (
            <>
              <h2
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  color: darkMode ? "#f8fafc" : "#1e293b",
                  marginTop: "0",
                  marginBottom: "24px",
                }}
              >
                Request Withdrawal
              </h2>

              <div style={{ marginBottom: "16px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: darkMode ? "#e2e8f0" : "#475569",
                  }}
                >
                  Amount ($)
                </label>
                <input
                  type="number"
                  value={cashoutForm.amount}
                  onChange={(e) =>
                    setCashoutForm({ ...cashoutForm, amount: e.target.value })
                  }
                  style={{
                    width: "100%",
                    padding: "12px",
                    borderRadius: "8px",
                    border: `1px solid ${darkMode ? "#334155" : "#e2e8f0"}`,
                    backgroundColor: darkMode ? "#1e293b" : "#ffffff",
                    color: darkMode ? "#f8fafc" : "#1e293b",
                    marginBottom: "16px",
                    fontSize: "16px",
                    outline: "none",
                  }}
                  placeholder="Enter amount"
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: darkMode ? "#e2e8f0" : "#475569",
                  }}
                >
                  Account Type
                </label>
                <select
                  value={cashoutForm.accountType}
                  onChange={(e) =>
                    setCashoutForm({
                      ...cashoutForm,
                      accountType: e.target.value,
                    })
                  }
                  style={{
                    width: "100%",
                    padding: "12px",
                    borderRadius: "8px",
                    border: `1px solid ${darkMode ? "#334155" : "#e2e8f0"}`,
                    backgroundColor: darkMode ? "#1e293b" : "#ffffff",
                    color: darkMode ? "#f8fafc" : "#1e293b",
                    marginBottom: "16px",
                    fontSize: "16px",
                    appearance: "none",
                    outline: "none",
                  }}
                >
                  <option value="">Select account type</option>
                  <option value="EasyPaisa">EasyPaisa</option>
                  <option value="JazzCash">JazzCash</option>
                </select>
              </div>

              <div style={{ marginBottom: "16px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: darkMode ? "#e2e8f0" : "#475569",
                  }}
                >
                  Account Number
                </label>
                <input
                  type="text"
                  value={cashoutForm.accountNumber}
                  onChange={(e) =>
                    setCashoutForm({
                      ...cashoutForm,
                      accountNumber: e.target.value,
                    })
                  }
                  style={{
                    width: "100%",
                    padding: "12px",
                    borderRadius: "8px",
                    border: `1px solid ${darkMode ? "#334155" : "#e2e8f0"}`,
                    backgroundColor: darkMode ? "#1e293b" : "#ffffff",
                    color: darkMode ? "#f8fafc" : "#1e293b",
                    marginBottom: "16px",
                    fontSize: "16px",
                    outline: "none",
                  }}
                  placeholder="Enter account number"
                />
              </div>

              <div style={{ marginBottom: "24px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: darkMode ? "#e2e8f0" : "#475569",
                  }}
                >
                  Remarks (Optional)
                </label>
                <textarea
                  value={cashoutForm.remarks}
                  onChange={(e) =>
                    setCashoutForm({ ...cashoutForm, remarks: e.target.value })
                  }
                  style={{
                    width: "100%",
                    padding: "12px",
                    borderRadius: "8px",
                    border: `1px solid ${darkMode ? "#334155" : "#e2e8f0"}`,
                    backgroundColor: darkMode ? "#1e293b" : "#ffffff",
                    color: darkMode ? "#f8fafc" : "#1e293b",
                    minHeight: "80px",
                    fontSize: "16px",
                    outline: "none",
                  }}
                  placeholder="Any additional information / Issue / Complain  "
                />
              </div>

              <button
                onClick={async () => {
                  try {
                    if (
                      !cashoutForm.amount ||
                      !cashoutForm.accountType ||
                      !cashoutForm.accountNumber
                    ) {
                      toast.error("Please fill all required fields");
                      return;
                    }

                    await axios.post(
                      "https://bioopay-full-backend.onrender.com/api/v1/cashout/create",
                      cashoutForm
                    );

                    toast.success("Withdrawal request submitted!");
                    setIsCashoutModalOpen(false);
                    setCashoutForm({
                      amount: "",
                      accountType: "",
                      accountNumber: "",
                      remarks: "",
                    });

                    // Refresh withdrawal history
                    const { data } = await axios.get(
                      `https://bioopay-full-backend.onrender.com/api/v1/cashout/my?t=${Date.now()}`,
                      { headers: { "Cache-Control": "no-cache" } }
                    );
                    setCashouts(data.cashouts || data || []);
                  } catch (error) {}
                }}
                style={{
                  width: "100%",
                  padding: "14px",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor: darkMode ? "#6366f1" : "#4f46e5",
                  color: "#ffffff",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                }}
              >
                Submit Withdrawal Request
              </button>
            </>
          ) : (
            <>
              <h2
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  color: darkMode ? "#f8fafc" : "#1e293b",
                  marginTop: "0",
                  marginBottom: "24px",
                }}
              >
                Withdrawal History
              </h2>

              {cashouts.length === 0 ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px 0",
                    color: darkMode ? "#94a3b8" : "#64748b",
                  }}
                >
                  No withdrawal history found
                </div>
              ) : (
                <div
                  style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                  }}
                >
                  {cashouts.map((withdrawal) => (
                    <div
                      key={withdrawal._id}
                      style={{
                        padding: "16px",
                        marginBottom: "12px",
                        borderRadius: "8px",
                        background: darkMode ? "#334155" : "#f1f5f9",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "8px",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "600",
                            color: darkMode ? "#f8fafc" : "#1e293b",
                          }}
                        >
                          ${withdrawal.amount}
                        </span>
                        <span
                          style={{
                            color:
                              withdrawal.status === "completed"
                                ? "#10b981"
                                : withdrawal.status === "pending"
                                ? "#f59e0b"
                                : "#ef4444",
                            fontWeight: "600",
                          }}
                        >
                          {withdrawal.status.charAt(0).toUpperCase() +
                            withdrawal.status.slice(1)}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "14px",
                          color: darkMode ? "#94a3b8" : "#64748b",
                        }}
                      >
                        <span>{withdrawal.accountType}</span>
                        <span>
                          {new Date(withdrawal.createdAt).toLocaleDateString()}
                        </span>
                      </div>
                      {withdrawal.remarks && (
                        <div
                          style={{
                            marginTop: "8px",
                            fontSize: "14px",
                            color: darkMode ? "#e2e8f0" : "#475569",
                          }}
                        >
                          {withdrawal.remarks}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </Modal>
      <Modal
        isOpen={isAdvanceModalOpen}
        onRequestClose={() => setIsAdvanceModalOpen(false)}
        style={{
          ...customStyles,
          content: {
            ...customStyles.content,
            maxWidth: "600px",
          },
        }}
        contentLabel="Advance Request"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "24px",
          }}
        >
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "700",
              margin: 0,
              color: darkMode ? "#f8fafc" : "#1e293b",
            }}
          >
            Advance
          </h2>
          <button
            onClick={() => setIsAdvanceModalOpen(false)}
            style={{
              background: "none",
              border: "none",
              color: darkMode ? "#94a3b8" : "#64748b",
              fontSize: "24px",
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>

        {/* Tab Navigation */}
        <div
          style={{
            display: "flex",
            borderBottom: `1px solid ${darkMode ? "#334155" : "#e2e8f0"}`,
            marginBottom: "24px",
          }}
        >
          <button
            onClick={() => setActiveTab("request")}
            style={{
              padding: "12px 16px",
              background: "none",
              border: "none",
              borderBottom: `2px solid ${
                activeTab === "request"
                  ? darkMode
                    ? "#6366f1"
                    : "#4f46e5"
                  : "transparent"
              }`,
              color:
                activeTab === "request"
                  ? darkMode
                    ? "#6366f1"
                    : "#4f46e5"
                  : darkMode
                  ? "#94a3b8"
                  : "#64748b",
              fontWeight: "600",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            Request Advance
          </button>
          <button
            onClick={() => setActiveTab("history")}
            style={{
              padding: "12px 16px",
              background: "none",
              border: "none",
              borderBottom: `2px solid ${
                activeTab === "history"
                  ? darkMode
                    ? "#6366f1"
                    : "#4f46e5"
                  : "transparent"
              }`,
              color:
                activeTab === "history"
                  ? darkMode
                    ? "#6366f1"
                    : "#4f46e5"
                  : darkMode
                  ? "#94a3b8"
                  : "#64748b",
              fontWeight: "600",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            History
          </button>
        </div>

        {/* Request Advance Tab */}
        {activeTab === "request" && (
          <>
            <div style={{ marginBottom: "20px" }}>
              <p
                style={{
                  fontSize: "14px",
                  color: darkMode ? "#94a3b8" : "#64748b",
                  backgroundColor: darkMode ? "#334155" : "#f1f5f9",
                  padding: "12px",
                  borderRadius: "8px",
                  marginBottom: "16px",
                }}
              >
                {defaultNote ||
                  "For apply advance you must have more than 2 to 3 active referral otherwise you are not eligible."}
              </p>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: darkMode ? "#e2e8f0" : "#475569",
                }}
              >
                Team Size Category
              </label>
              <select
                value={advanceForm.teamCategory}
                onChange={(e) => {
                  setAdvanceForm({
                    ...advanceForm,
                    teamCategory: e.target.value,
                    amountRequested: calculateAdvanceAmount(e.target.value),
                  });
                }}
                style={{
                  width: "100%",
                  padding: "12px",
                  borderRadius: "8px",
                  border: `1px solid ${darkMode ? "#334155" : "#e2e8f0"}`,
                  backgroundColor: darkMode ? "#1e293b" : "#ffffff",
                  color: darkMode ? "#f8fafc" : "#1e293b",
                  marginBottom: "16px",
                  fontSize: "16px",
                  outline: "none",
                }}
              >
                <option value="">Select team size category</option>
                <option value="1-20">1-20 Members</option>
                <option value="21-50">21-50 Members</option>
                <option value="51-100">51-100 Members</option>
                <option value="100+">100+ Members</option>
              </select>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: darkMode ? "#e2e8f0" : "#475569",
                }}
              >
                Calculated Advance Amount ($)
              </label>
              <input
                type="number"
                value={advanceForm.amountRequested}
                readOnly
                style={{
                  width: "100%",
                  padding: "12px",
                  borderRadius: "8px",
                  border: `1px solid ${darkMode ? "#334155" : "#e2e8f0"}`,
                  backgroundColor: darkMode ? "#334155" : "#f1f5f9",
                  color: darkMode ? "#f8fafc" : "#1e293b",
                  marginBottom: "16px",
                  fontSize: "16px",
                  outline: "none",
                  cursor: "not-allowed",
                }}
              />
            </div>

            <div style={{ marginBottom: "24px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: darkMode ? "#e2e8f0" : "#475569",
                }}
              >
                Your Comments (Optional)
              </label>
              <textarea
                value={advanceForm.userComment}
                onChange={(e) =>
                  setAdvanceForm({
                    ...advanceForm,
                    userComment: e.target.value,
                  })
                }
                style={{
                  width: "100%",
                  padding: "12px",
                  borderRadius: "8px",
                  border: `1px solid ${darkMode ? "#334155" : "#e2e8f0"}`,
                  backgroundColor: darkMode ? "#1e293b" : "#ffffff",
                  color: darkMode ? "#f8fafc" : "#1e293b",
                  minHeight: "100px",
                  fontSize: "16px",
                  outline: "none",
                }}
                placeholder="Explain why you need this advance..."
              />
            </div>

            <button
              onClick={submitAdvanceRequest}
              style={{
                width: "100%",
                padding: "14px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: darkMode ? "#6366f1" : "#4f46e5",
                color: "#ffffff",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "background-color 0.2s",
                ":hover": {
                  backgroundColor: darkMode ? "#4f46e5" : "#4338ca",
                },
              }}
            >
              Submit Advance Request
            </button>
          </>
        )}

        {/* History Tab */}
        {activeTab === "history" && (
          <div
            style={{
              backgroundColor: darkMode ? "#1e293b" : "#ffffff",
              borderRadius: "12px",
              padding: "0",
            }}
          >
            <h3
              style={{
                fontSize: "20px",
                fontWeight: "700",
                margin: "0 0 16px 0",
                color: darkMode ? "#f8fafc" : "#1e293b",
              }}
            >
              Your Advance Requests History
            </h3>

            {advances.length === 0 ? (
              <p
                style={{
                  textAlign: "center",
                  color: darkMode ? "#94a3b8" : "#64748b",
                  padding: "20px 0",
                }}
              >
                No advance requests found
              </p>
            ) : (
              <div
                style={{
                  maxHeight: "400px",
                  overflowY: "auto",
                }}
              >
                {advances.map((advance) => (
                  <div
                    key={advance._id}
                    style={{
                      padding: "16px",
                      marginBottom: "12px",
                      borderRadius: "8px",
                      backgroundColor: darkMode ? "#334155" : "#f1f5f9",
                      borderLeft: `4px solid ${
                        advance.status === "approved"
                          ? "#10b981"
                          : advance.status === "rejected"
                          ? "#ef4444"
                          : "#f59e0b"
                      }`,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "8px",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "600",
                          color: darkMode ? "#f8fafc" : "#1e293b",
                        }}
                      >
                        ${advance.calculatedAdvanceAmount}
                      </span>
                      <span
                        style={{
                          fontWeight: "600",
                          color: darkMode ? "#f8fafc" : "#1e293b",
                        }}
                      >
                        {advance.remarks}
                      </span>
                      <span
                        style={{
                          color:
                            advance.status === "approved"
                              ? "#10b981"
                              : advance.status === "rejected"
                              ? "#ef4444"
                              : "#f59e0b",
                          fontWeight: "600",
                        }}
                      >
                        {advance.status.charAt(0).toUpperCase() +
                          advance.status.slice(1)}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        color: darkMode ? "#94a3b8" : "#64748b",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Team: {advance.teamCategory}</span>
                      <span>
                        {new Date(advance.createdAt).toLocaleDateString()}
                      </span>
                    </div>
                    {advance.userComment && (
                      <div
                        style={{
                          marginTop: "8px",
                          fontSize: "14px",
                          color: darkMode ? "#e2e8f0" : "#475569",
                        }}
                      >
                        <strong>Your Note:</strong> {advance.userComment}
                      </div>
                    )}
                    {advance.remarks && (
                      <div
                        style={{
                          marginTop: "8px",
                          fontSize: "14px",
                          color:
                            advance.status === "rejected"
                              ? "#ef4444"
                              : "#10b981",
                        }}
                      >
                        <strong>Admin Remarks:</strong> {advance.remarks}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </Modal>
    </Layout>
  );
};

export default UserDashboard;
